import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import DataTable from "components/DataTable"
import { useRefined } from "../ui/refined"

// Thin wrapper over the shared DataTable that standardises loading / empty /
// null-safe states across every procurement list. Rows are always coerced to
// an array so a missing/late response never throws.
const ScopedDataTable = ({
  columns = [],
  rows,
  isLoading = false,
  emptyText = "No records found.",
  ...rest
}) => {
  const refined = useRefined()
  if (isLoading) {
    if (refined) return <p className="pc-section-empty pc-section-empty--flush">Loading…</p>
    return (
      <MDBox py={3}>
        <MDTypography variant="body2" color="text">
          Loading…
        </MDTypography>
      </MDBox>
    )
  }

  const safeRows = Array.isArray(rows) ? rows : []

  if (safeRows.length === 0) {
    if (refined) return <p className="pc-section-empty pc-section-empty--flush">{emptyText}</p>
    return (
      <MDBox py={3}>
        <MDTypography variant="body2" color="text">
          {emptyText}
        </MDTypography>
      </MDBox>
    )
  }

  return (
    <DataTable
      table={{ columns, rows: safeRows }}
      noEndBorder
      entriesPerPage={{ isShow: false }}
      className={refined ? "pc-md-table" : undefined}
      {...rest}
    />
  )
}

export default ScopedDataTable
